import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'ordenarAlfabeticamente',
  pure: false
})
export class OrdenarAlfabeticamentePipe implements PipeTransform {

  transform(datos: any[]): any {
    return Array.from(datos).sort(function(a,b){ return a>b?1:-1});
  }

}
